let initPromise: Promise<any> | null = null;

export function initChartJsOnce() {
  if (initPromise) return initPromise;

  initPromise = (async () => {
    const chartJs = await import('chart.js');
    const datalabels = await import('chartjs-plugin-datalabels');

    const {
      Chart,
      ArcElement,
      BarController,
      BarElement,
      CategoryScale,
      LinearScale,
      PieController,
      DoughnutController,
      LineController,
      LineElement,
      PointElement,
      Legend,
      Title,
      Tooltip,
      SubTitle,
      Filler,
    } = chartJs as any;

    Chart.register(
      ArcElement,
      BarElement,
      BarController,
      LineController,
      PieController,
      DoughnutController,
      CategoryScale,
      LinearScale,
      LineElement,
      PointElement,
      Filler,
      Legend,
      Title,
      Tooltip,
      SubTitle,
      datalabels.default ?? datalabels
    );

    Chart.defaults.set('plugins.datalabels', { display: false });

    return Chart;
  })();

  return initPromise;
}
